import { css } from '@emotion/react';
import { Button } from 'react-bootstrap';
import { gray3, highTide, primary } from 'styles/global_defaults/colors';
import { doubleSpacing, halfSpacing, standardSpacing } from 'styles/global_defaults/scaffolding';


type NvRoundButtonProps = {
  icon?: string,
  onClick?: (event: any) => void,
  className?: string,
  label?: string,
  disabled?: boolean,
  pendoTag?: string,
  ariaLabel?: string,
  dataQa?: string,
};

const buttonStyles = css`
  &.nv-icon-button {
    background-color: transparent;
    border: 0;
    border-radius: ${standardSpacing}px;
    color: ${primary};
    font-weight: 400;
    height: ${doubleSpacing}px;
    margin: 0 ${halfSpacing}px;

    &.disabled {
      color: ${gray3};
    }

    &.icon-only:hover {
      background-color: transparent;
    }

    &.round-button:hover {
      background-color: transparent;
      color: ${highTide};
    }
  }
`;

const NvRoundButton = (props: NvRoundButtonProps) => (
  <Button
    css={buttonStyles}
    className={`nv-icon-button round-button ${props.disabled ? 'disabled' : ''} ${!props.label?.length ? 'icon-only' : ''} ${props.className}`}
    onClick={(e) => props.onClick?.(e)}
    disabled={props.disabled}
    pendo-tag-name={props.pendoTag}
    aria-label={props.ariaLabel}
    data-qa={props.dataQa}
  >
    {props.icon && <i className={props.icon} />} {props.label}
  </Button>
);

export default NvRoundButton;
